import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/features/events/services/dashboard.service';

@Component({
  selector: 'app-gigantes.outlet',
  templateUrl: './gigantes.outlet.component.html',
  styleUrls: ['./gigantes.outlet.component.css'],
  providers: [DashboardService],
})
export class GigantesOutletComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
